const site = {
  origin: 'https://whitepearlink.ch',
  name: 'White Pearl Ink',
  artist: 'Rebecca Sophia',
  email: 'rebecca.sophiaa.p@gmail.com',
  instagram: 'https://www.instagram.com/whitepearl.ink/',
  image: '/galleries/tattoo_startseite/1749282107111.webp',
};

const pages = {
  '/': {
    title: 'Tattoostudio Kreuzlingen – Fineline & Kunst | White Pearl Ink',
    description:
      'Fineline und Light Blackwork Tattoos von Rebecca Sophia in Kreuzlingen am Bodensee, nahe Konstanz. Natur, Fantasy und individuelle Kunstwerke.',
    label: 'Startseite',
    galleries: ['tattoo_startseite', 'art_startseite', 'aboutme_selfie'],
  },
  '/tattoos': {
    title: 'Fineline Tattoo Kreuzlingen, nahe Konstanz | White Pearl Ink',
    description:
      'Florale Motive, Tier- und Fantasy-Tattoos in Fineline und Light Blackwork. Entdecke Rebeccas Arbeiten und frage deinen Termin in Kreuzlingen an.',
    label: 'Tattoos',
    galleries: ['tattoo_portfolio', 'tattoo_startseite', 'aboutme_selfie'],
    service: 'Fineline und Light Blackwork Tattoos',
  },
  '/art': {
    title: 'Kunstwerke & Auftragskunst aus Kreuzlingen | White Pearl Ink',
    description:
      'Digital Art, Acryl, Aquarell und Seelenbilder von Rebecca Sophia. Entdecke das Portfolio oder frage dein persönliches Kunstwerk an.',
    label: 'Kunstwerke',
    image: '/galleries/art_startseite/1749281938161.webp',
    galleries: ['art_portfolio', 'art_startseite'],
    service: 'Kunstwerke und Seelenbilder',
  },
  '/tierportraets': {
    title: 'Tierporträt zeichnen lassen nach Foto | White Pearl Ink',
    description:
      'Deinen Hund, deine Katze oder ein anderes Haustier zeichnen lassen. Individuelle Tierporträts nach Foto von Rebecca Sophia aus Kreuzlingen, Schweiz.',
    label: 'Tierporträts nach Foto',
    parent: '/art',
    image: '/galleries/art_portfolio/1780504846523.webp',
    imageAlt: 'Porträt von zwei Hunden vor einem Wald von Rebecca Sophia',
    service: 'Individuelle Tierporträts nach Foto',
  },
  '/auftragskunst': {
    title: 'Auftragskunst – Kunst nach Wunsch | White Pearl Ink',
    description:
      'Tierporträts, persönliche Bilder und Illustrationen für besondere Anlässe. Individuelle Kunst nach Wunsch von Rebecca Sophia aus Kreuzlingen.',
    label: 'Kunst nach Wunsch',
    parent: '/art',
    image: '/galleries/art_portfolio/1749282393369.webp',
    imageAlt: 'Illustration mit einem Porträt und nautischen Motiven von Rebecca Sophia',
    service: 'Individuelle Auftragskunst und Illustrationen',
  },
  '/about-me': {
    title: 'Rebecca Sophia – Künstlerin & Tätowiererin | White Pearl Ink',
    description:
      'Lerne Rebecca Sophia kennen: Tätowiererin und Künstlerin bei White Pearl Ink in Kreuzlingen. Tattoos und Kunst, inspiriert von Natur und Fantasy.',
    label: 'Über mich',
    image: '/galleries/aboutme_selfie/1767377163277.webp',
    galleries: ['aboutme_selfie'],
  },
  '/pets': {
    title: 'Haustier-Tattoo & Erinnerungsmotive in Kreuzlingen | White Pearl Ink',
    description:
      'Deinen Hund oder deine Katze als Fineline-Tattoo verewigen. Individuelle Haustier-Tattoos und Erinnerungsmotive bei Rebecca Sophia in Kreuzlingen.',
    label: 'Haustiere verewigen',
    service: 'Haustier-Tattoos und Erinnerungsmotive',
  },
  '/studio': {
    title: 'Tattoostudio Kreuzlingen – Adresse & Anfahrt | White Pearl Ink',
    description:
      'White Pearl Ink am Alleeweg 12 in 8280 Kreuzlingen, nahe Konstanz. Privates Tattoostudio von Rebecca Sophia. Termine nach Vereinbarung.',
    label: 'Studio & Anfahrt',
  },
  '/anfrage': {
    title: 'Tattoo-Termin in Kreuzlingen anfragen | White Pearl Ink',
    description:
      'Erzähl Rebecca von deiner Tattoo-Idee. Unverbindliche Anfrage für Fineline und Light Blackwork im privaten Studio White Pearl Ink in Kreuzlingen.',
    label: 'Tattoo anfragen',
    galleries: ['aboutme_selfie'],
  },
  '/impressum': {
    title: 'Impressum | White Pearl Ink',
    description: 'Angaben zu White Pearl Ink und Kontakt zu Rebecca Sophia in Kreuzlingen.',
    label: 'Impressum',
    noindex: true,
  },
  '/datenschutz': {
    title: 'Datenschutz | White Pearl Ink',
    description: 'Informationen zum Datenschutz auf der Website von White Pearl Ink.',
    label: 'Datenschutz',
    noindex: true,
  },
  '/admin/images': {
    title: 'Galerien verwalten | White Pearl Ink',
    description: 'Galerieverwaltung von White Pearl Ink.',
    noindex: true,
    private: true,
  },
  '/appointments': {
    title: 'Termine | White Pearl Ink',
    description: 'Terminverwaltung von White Pearl Ink.',
    noindex: true,
    private: true,
  },
};

function getPage(path) {
  const clean = path.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase() || '/';
  if (clean.startsWith('/appointment/')) {
    return {
      title: 'Dein Termin | White Pearl Ink',
      description: 'Dein persönlicher Termin bei White Pearl Ink.',
      noindex: true,
      private: true,
      path: clean,
    };
  }
  return pages[clean]
    ? { ...pages[clean], path: clean }
    : {
        title: 'Seite nicht gefunden | White Pearl Ink',
        description:
          'Diese Seite wurde nicht gefunden. Entdecke Tattoos und Kunstwerke bei White Pearl Ink.',
        noindex: true,
        notFound: true,
        path: clean,
      };
}

function getSchema(page) {
  if (page.noindex) return null;
  const studioId = site.origin + '/#studio';
  const artistId = site.origin + '/#rebecca';
  const url = site.origin + page.path;
  const artPage = ['/art', '/tierportraets', '/auftragskunst'].includes(page.path);
  const graph = [
    {
      '@type': 'TattooParlor',
      '@id': studioId,
      name: site.name,
      url: site.origin + '/',
      description:
        'Privates Tattoostudio in Kreuzlingen für Fineline und Light Blackwork Tattoos, inspiriert von Natur und Fantasy. Termine nach Vereinbarung.',
      image: site.origin + site.image,
      logo: site.origin + '/android-chrome-512x512.png',
      email: site.email,
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Alleeweg 12',
        postalCode: '8280',
        addressLocality: 'Kreuzlingen',
        addressRegion: 'Thurgau',
        addressCountry: 'CH',
      },
      geo: { '@type': 'GeoCoordinates', latitude: 47.64787969243006, longitude: 9.170366008238716 },
      hasMap: 'https://maps.google.com/?q=Alleeweg+12+8280+Kreuzlingen',
      sameAs: [site.instagram],
      founder: { '@id': artistId },
      areaServed: ['Kreuzlingen', 'Konstanz', 'Thurgau', 'Bodenseeregion', 'Zürich', 'St. Gallen'],
    },
    {
      '@type': 'Person',
      '@id': artistId,
      name: site.artist,
      url: site.origin + '/about-me',
      jobTitle: 'Künstlerin und Tätowiererin',
      image: site.origin + '/galleries/aboutme_selfie/1767377163277.webp',
      worksFor: { '@id': studioId },
      sameAs: [site.instagram, 'https://www.instagram.com/rebecca.sophiaa/'],
    },
    {
      '@type': 'WebSite',
      '@id': site.origin + '/#website',
      name: site.name,
      url: site.origin + '/',
      inLanguage: 'de-CH',
      publisher: { '@id': studioId },
    },
    {
      '@type': page.path === '/about-me' ? 'AboutPage' : 'WebPage',
      '@id': url + '#webpage',
      url,
      name: page.title,
      description: page.description,
      inLanguage: 'de-CH',
      isPartOf: { '@id': site.origin + '/#website' },
      about: { '@id': page.path === '/about-me' || artPage ? artistId : studioId },
      ...(page.service ? { mainEntity: { '@id': url + '#service' } } : {}),
      ...(page.path !== '/' ? { breadcrumb: { '@id': url + '#breadcrumb' } } : {}),
    },
  ];
  if (page.service)
    graph.push({
      '@type': 'Service',
      '@id': url + '#service',
      name: page.service,
      description: page.description,
      url,
      serviceType: page.service,
      provider: { '@id': artPage ? artistId : studioId },
    });
  if (page.path !== '/') {
    const trail = [{ name: 'Startseite', item: site.origin + '/' }];
    if (page.parent)
      trail.push({ name: pages[page.parent].label, item: site.origin + page.parent });
    trail.push({ name: page.label, item: url });
    graph.push({
      '@type': 'BreadcrumbList',
      '@id': url + '#breadcrumb',
      itemListElement: trail.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        ...item,
      })),
    });
  }
  return { '@context': 'https://schema.org', '@graph': graph };
}

function getMeta(path) {
  const page = getPage(path);
  return {
    ...page,
    canonical: page.notFound || page.private ? null : site.origin + page.path,
    robots: page.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large',
    image: site.origin + (page.image || site.image),
    imageAlt:
      page.imageAlt ||
      (page.image
        ? page.label + ' – ' + site.artist
        : 'Fineline-Tattoo von White Pearl Ink in Kreuzlingen'),
    schema: getSchema(page),
  };
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function safeJson(value) {
  return JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}

function renderHead(path) {
  const meta = getMeta(path);
  const tags = [`<title>${escapeHtml(meta.title)}</title>`];
  const named = {
    description: meta.description,
    robots: meta.robots,
    googlebot: meta.robots,
    'twitter:card': 'summary_large_image',
    'twitter:title': meta.title,
    'twitter:description': meta.description,
    'twitter:image': meta.image,
    'twitter:image:alt': meta.imageAlt,
  };
  const properties = {
    'og:type': 'website',
    'og:site_name': site.name,
    'og:locale': 'de_CH',
    'og:title': meta.title,
    'og:description': meta.description,
    'og:image': meta.image,
    'og:image:alt': meta.imageAlt,
    ...(meta.canonical ? { 'og:url': meta.canonical } : {}),
  };
  for (const [name, content] of Object.entries(named))
    tags.push(`<meta name="${name}" content="${escapeHtml(content)}">`);
  for (const [property, content] of Object.entries(properties))
    tags.push(`<meta property="${property}" content="${escapeHtml(content)}">`);
  if (meta.canonical) tags.push(`<link rel="canonical" href="${escapeHtml(meta.canonical)}">`);
  if (meta.schema)
    tags.push(
      `<script id="site-schema" type="application/ld+json">${safeJson(meta.schema)}</script>`
    );
  return tags.join('\n');
}

function renderSitemap() {
  return (
    '<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n' +
    Object.keys(pages)
      .filter((path) => !pages[path].noindex)
      .map((path) => `  <url><loc>${site.origin}${path}</loc></url>`)
      .join('\n') +
    '\n</urlset>\n'
  );
}

module.exports = { site, pages, getMeta, renderHead, renderSitemap, safeJson };
